<section>
  <h1 class="mat-display-1">You have opted out of email!</h1>
</section>
<div class="content">
  <div class="optout">
    <h3>
      The email '{{email()}}' will <strong>no longer</strong> receive emails from cloudigo regarding news and offers.
      If you wish to revoke this change or do other changes, <a routerLink="/profile">visit your profile here</a>.
    </h3>
    <button mat-flat-button routerLink="/">
      Continue to cloudigo
    </button>
  </div>
</div>